import EcoImg from 'eco-design/base/eco-img';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import { useRouter } from 'next/router';
import React, { useMemo } from 'react';
import AnimatedSection from '../../us/StatusA/Components/AnimatedSection';
import HoverBtn from '../HoverBtn';
import styles from './index.module.scss';
import { useLang } from '@/app/utils/useLang';

interface CardSectionConfig {
    title: string;
    desc: React.ReactNode;
    pc: string;
    pad: string;
    h5: string;
    btnText: string;
    moreText: string;
}
export default function CardSection(props: { config?: Partial<CardSectionConfig> }) {
    const { pathname } = useRouter();
    const { t } = useLang('CardSection');

    const defaultConfig = {
        title: t('title'),
        desc: t.rich('desc', {
            sup: (text: string) => <sup>{text}</sup>,
        }),
        pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758083515028-ao7a98-compressed-%E5%A4%A7%E5%9B%BE.jpg',
        pad: 'https://websiteoss.ecoflow.com/figma-uploads/1758083515028-ao7a98-compressed-%E5%A4%A7%E5%9B%BE.jpg',
        h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758181328675-cavzq6-compressed-Frame%202094654416.jpg',
        btnText: t('btnText'),
        moreText: t('moreText'),
    };

    const pageType = useMemo(() => {
        if (pathname.includes('/delta-3-max-plus-portable-power-station')) {
            return 'max';
        }
        return 'ultra';
    }, [pathname]);

    console.log('pageType', pageType, pathname);

    const config = { ...defaultConfig, ...props.config };

    return (
        <div className={`page-CardSection ${styles.CardSection} GtmModuleData-section`} id="CardSection" data-section-id="d3m-card-section">
            <AnimatedSection variant="fadeInUp" options={{ delay: 400 }}>
                <EcoSectionCommon className={`section-content pad-show enter`} title={config.title} desc={config.desc} />
            </AnimatedSection>
            <AnimatedSection variant="fadeInUp" options={{ delay: 400 }}>
                <div className="card-section-container">
                    <EcoImg pc={config.pc} pad={config.pad} h5={config.h5} isOpenLazy={true} />
                    <div className="card-section-box">
                        <AnimatedSection variant="fadeInUp" options={{ delay: 400 }}>
                            <EcoSectionCommon className={`section-content pc-show enter`} title={config.title} desc={config.desc} />
                        </AnimatedSection>
                        <div className={`imgs-box-bottom ${pageType}-box`}>
                            <HoverBtn className={`${pageType}-content`} text={config.btnText} desc={config.moreText} />
                        </div>
                    </div>
                </div>
            </AnimatedSection>
        </div>
    );
}
